import { useState, useEffect } from 'react';
import ready from 'document-ready';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import PaymentAuthorizationSubmitButtons from '@Components/Shared/Payments/PaymentAuthorizationSubmitButtons';

const FirstDataForm = (props) => {

    /*!
    * Documentation
    * https://developer.cardconnect.com/hosted-iframe-tokenizer
    * https://developer.cardconnect.com/guides/cardpointe-gateway#processing-ach-payments
    * https://developer.cardconnect.com/guides/cardpointe-gateway#uat-test-card-data
    */

    const [error, setError] = useState('');
    const [render, setRender] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentResponse, setCurrentResponse] = useState(false);

    useEffect(() => {
        ready(() => {
            window.addEventListener('message', function (event) {
                let response = JSON.parse(event.data);
                setCurrentResponse(response);
            }, false);

            setRender(true);
            props.ready?.();
        });
    }, []);

    const validateTokenResponse = (response) => {
        if (response?.errorCode == "0" && response?.token) {
            props.setError('');
            let fullResponse = { ...response, ...props };
            fullResponse.PaymentMethodID = response.token;
            props.success?.(fullResponse);
        }
        else {
            props.setError("An Error has Occurred. Please verify payment method information above.");
        }
    };

    const submitForm = () => {
        if (!props.loading) {
            props.validateForm(requestCardToken);
        }       
    };

    const requestCardToken = () => {
        props.setLoading(true);
        // click outside of iFrame input to submit data to First Data Hosted iFrame Tokenizer
        document.getElementById('payment-form').click();
        // add 1 second delay to get response back
        setTimeout(function () {
            // verify latest response from First Data Hosted iFrame Tokenizer
            validateTokenResponse(currentResponse);
            props.setLoading(false);
        }, 1000);
    };

    return (
        <div>
            {props.loading && <LoadingRing sxBox={{ 'justify-content': 'center' }} />}
            <form id='payment-form'>
                {(render && props.ScriptURL) &&
                    <iframe title="Payment Form" src={props.ScriptURL} frameBorder="0" scrolling="no" style={{ height: '200px', width: '100%' }} />
                }               
                <div id='credit-card-error' className="error" style={{ textAlign: 'center', marginBottom: '15px' }}>
                    {props.error && <>{props.error}</>}
                </div>
                <PaymentAuthorizationSubmitButtons
                    {...props}
                    submitForm={submitForm}
                />
            </form>
        </div>
    );
}

export default FirstDataForm;